import React from 'react';

// disable eslint because it gets upset about the long tag below
/* eslint-disable */

/**
 * @typedef {object} CheckedXIconProps
 * @property {"small"|"medium"} [size]
 */

/**
 * @param {CheckedXIconProps} props
 */
const CheckedXIcon = (props) => {
  const { size } = props;

  const iconSize = size === 'small' ? 20 : 24;

  return <svg xmlns="http://www.w3.org/2000/svg"
              enableBackground="new 0 0 24 24"
              height={`${iconSize}px`}
              viewBox="0 0 24 24"
              width={`${iconSize}px`}
              fill="currentColor">
    <rect fill="none" height={iconSize} width={iconSize} />
    <path d="M17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41L8.41,7L12,10.59L15.59,7 L17,8.41L13.41,12L17,15.59z" />
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </svg>
}
/* eslint-enable */

export default CheckedXIcon;
